import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { clientCheckAuth } from "../../store/thunks/clientAuthThunks";
import { FacturacionTopBar } from "./components/FacturacionTopBar";
import { FacturacionRouter } from "../../routes/FacturacionRouter";

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";

export const FacturacionLayout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading, isAuthenticated, client } = useAppSelector((state) => state.clientAuth);

  useEffect(() => {
    dispatch(clientCheckAuth());
  }, [dispatch]);

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      navigate("/facturacion/login", { replace: true });
      return;
    }

    if (client && !client.isProfileComplete) {
      const isProfilePath = location.pathname.startsWith("/facturacion/perfil");
      if (!isProfilePath) {
        navigate("/facturacion/perfil", { replace: true });
      }
    }
  }, [isLoading, isAuthenticated, client, location.pathname, navigate]);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) return null;

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
        <FacturacionTopBar />
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <FacturacionRouter />
        </Box>
      </Box>
    </GoogleOAuthProvider>
  );
};
